// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__JkquG"};